define('cart_promocode_list.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('cart_promocode_list', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-view=\"PromocodeList\"></div>  ";
},"useData":true}, 'extensions/Dev/SGS_Latest_Theme/1.0.0/', 'extensions/Dev/SGS_Latest_Theme/1.0.0/', Handlebars);
});